import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import './TopPage.css';
import HomePage from "./HomePage";
import CommpanyPage from "./CommpanyPage";
import BussinessPage from "./BussinessPage";
import AccessPage from "./AccessPage";

function TopPage(){
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("HomePage");
  const [menuOpen, setMenuOpen] = useState(false);

  const tabContents = {
    HomePage: {
      view: (
        <HomePage />
      ),
    },
    Page2: {
      view: (
       <BussinessPage />
      ),
    },
    Page3: {
      view: (
        <CommpanyPage />
      ),
    },
    Page4: {
      view: (
        <AccessPage />
      ),
    },
  };

  const tabName = ['ホーム', '事業紹介', '会社概要','アクセス情報', '何かしら'];

  return (
    <div className="TopPage">
      <div className="title-row">
        {/* タイトル */}
        <div className="title-div">
          <img
            src="/images/logo_takahashi.png"
            alt="株式会社高橋機工"
            className="title-logo"
          />
        </div>

        <div className="header-actions">
          <button
            type="button"
            className="contact-button"
            onClick={() => navigate("/contact")}
          >
            お問い合わせ
          </button>

          {/* モバイル用メニュー */}
          <div className="mobile-menu-bar">
            <button
              type="button"
              className={`mobile-menu-button ${menuOpen ? "is-open" : ""}`}
              aria-label={menuOpen ? "メニューを閉じる" : "メニューを開く"}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((prev) => !prev)}
            >
              <span className="mobile-menu-icon" />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}>
          <div className="mobile-menu-panel" onClick={(event) => event.stopPropagation()}>
            {Object.keys(tabContents).map((tab, index) => (
              <button
                type="button"
                key={tab}
                className={`mobile-menu-item ${activeTab === tab ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(tab);
                  setMenuOpen(false);
                }}
              >
              <span className="mobile-menu-label">{tabName[index]}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* タブ */}
      <div className="tabs">
        {Object.keys(tabContents).map((tab, index) => (
          <div
            key={tab}
            className={`tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tabName[index]}
          </div>
        ))}
      </div>

      {/* タブコンテンツ */}
      <div className="tab-content">
        {tabContents[activeTab].view}
      </div>
        <footer className='common-footer'>
            <p>Copyright© All Rights Reserved.</p>
        </footer>
      
    </div>
  );
};

export default TopPage;
